/**
 * マッチ度の表示の設定 (IN-M-009) の読み方 (画面レイアウト_SCR-M-001.md §6.4.5、Issue #1435)。
 *
 * 非表示かどうかはサーバが判定して応答の score_hidden に入れる (PBI-002 §11.8)。
 * 画面は recommendations の要素を数え直さない (判定を画面と PDF で別々にしないため)。
 * 応答に項目が無い (BE の反映前) ときは「表示」とし、改める前と同じ画面にする。
 *
 * @param {object|null|undefined} matchingResult 実行・画面復帰・設定の保存の応答
 * @returns {boolean} 非表示なら true
 */
export function isScoreHidden(matchingResult) {
    return matchingResult?.score_hidden === true;
}
